import { useIntl } from "react-intl";
import { ELEMENT_CODES } from "@/lib/elements";
import { POWER_BY_ABBR } from "@/lib/power-library";
import type { OrganizationalPowerAnalysis } from "./organizational-power-analysis";

/** The proposed powers of an organizational analysis: name, score and rationale, as reviewed before applying. */
export function OrganizationalPowerTraitList({ id, traits, className = "" }: {
  id?: string; traits: OrganizationalPowerAnalysis["traits"]; className?: string;
}) {
  const intl = useIntl();
  return <div id={id} className={`divide-y divide-ink/10 ${className}`}>
    {traits.map(trait => {
      const abbreviation = ELEMENT_CODES[trait.element];
      const power = abbreviation ? POWER_BY_ABBR[abbreviation] : undefined;
      return <div key={trait.element} className="space-y-2 py-4">
        <div className="flex items-center justify-between gap-4 smycles-field-value">
          <span>{power ? intl.formatMessage({ id: power.nameId }) : trait.element}</span>
          <span className="tabular-nums">{trait.score}/100</span>
        </div>
        {trait.rationale && <p className="smycles-field-meta text-ink-muted">{trait.rationale}</p>}
      </div>;
    })}
  </div>;
}
